import { useAccount, useConnect, useDisconnect } from '@starknet-react/core';
import { useMemo } from 'react';

export function useWallet() {
  const { address, isConnected, isConnecting, status, connector } = useAccount();
  const { connect, connectors, isPending: isConnectPending } = useConnect();
  const { disconnect } = useDisconnect();

  const shortAddress = useMemo(() => {
    if (!address) return '';
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  }, [address]);

  return {
    // Connection state
    address,
    shortAddress,
    isConnected,
    isConnecting: isConnecting || isConnectPending,
    status,

    // Current connector
    connector,
    connectorName: connector?.name,

    // Actions
    connect,
    disconnect,

    // Available connectors
    connectors,
  };
}
